import React, { useState, useEffect, useRef } from "react";
import {Card, Table, Button, Modal, Form, Input, Select, Upload, message, Image, Skeleton, Switch } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import axiosInstance from "../../../axiosInterceptor";
import styled from "styled-components";
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { MenuOutlined } from '@ant-design/icons';

const { Option } = Select;




const DraggableRow = ({ index, moveRow, className, style, ...restProps }) => {
  const ref = React.useRef(null);

  const [, drop] = useDrop({
    accept: "row",
    hover: (draggedItem) => {
      if (!draggedItem || draggedItem.index === index) return;
      
      console.log(`🔥 Item ${draggedItem.index} está sobre ${index}`);
      moveRow(draggedItem.index, index);
      draggedItem.index = index; // Atualiza o índice do item arrastado
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "row",
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  console.log(`🎯 Linha renderizada: ${index}`);

  return (
    <tr
      ref={ref}
      className={className}
      style={{
        ...style,
        cursor: "move",
        opacity: isDragging ? 0.5 : 1,
      }}
      {...restProps}
    />
  );
};



const EditarLinks = () => {

  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const [idLoja, setIDLoja] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [form] = Form.useForm();
  const [loja, setLoja] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [tipoSelecionado, setTipoSelecionado] = useState("link");
  const [redeSelecionada, setRedeSelecionada] = useState("Nenhuma");

  const [mostrarMapa, setMostrarMapa] = useState(false);
  const [tipoMapa, setTipoMapa] = useState("maps");


  const [modalVisible, setModalVisible] = useState(false);




  useEffect(() => {
    if (idUser) {
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };
      axiosInstance.get(
        `https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`,
        options
      ).then((resp) => {
        setIDLoja(resp.data.id);
        setLoja(resp.data);
      });
    }
  }, [idUser]);

  useEffect(() => {
    if (idUser) {
        const options = {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          };
      axiosInstance.get(`https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`, options)
        .then(resp => setIDLoja(resp.data.id));
    }
  }, [idUser]);

  const loadDados = () => {
    setLoading(true);

    const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

axiosInstance.get(`https://api.pedtech.com.br/v1/pedtech/getByEmpresa/${idLoja}`, options)
  .then(resp => {
    try {
      const data = resp.data?.SocialInfos || {};
      console.log("Dados recebidos:", data);

      // Converte a string JSON para um array, caso seja necessário
      const links = data.linksList ? JSON.parse(data.linksList) : [];
      setMostrarMapa(data.mostrarMapa !== undefined ? data.mostrarMapa : false);
      setTipoMapa(data.tipoMapa || "maps");

      console.log("Links processados:", links);
      setLinks(links);
      setMostrarMapa(false);
      setTipoMapa("maps");
    } catch (error) {
      console.error("Erro ao processar os links:", error);
      setLinks([]);
      setMostrarMapa(false);
      setTipoMapa("maps");
    } finally {
      setLoading(false);
    }
  })
  .catch(error => {
    console.error("Erro ao buscar os links:", error);
    setLinks([]); // Garante que o estado seja um array vazio em caso de erro
    setLoading(false);
  });
}


  useEffect(() => {
    setLoading(true);

    if (idUser && idLoja) {
      loadDados();
    }
  }, [idUser, accessToken, idLoja]);


  const handleSaveBanco = (json) => {
    console.log(json);
   
    let mostrarMapaAux = 0;
    if(mostrarMapa){
      mostrarMapaAux = 1
    }
    const jsonData = {
      linksList: JSON.stringify(json),
      mostrarMapa: mostrarMapaAux,   
      tipoMapa: tipoMapa
    };
  
    console.log(JSON.stringify(jsonData));
    try {
      setLoading(true);
      const options = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      axiosInstance.put(
        `https://api.pedtech.com.br/v1/pedtech/links/`+idLoja, jsonData,
        options
      ).then((resp) => {
        if (resp.status == 200) {
          message.success('Conteudo salvo!');
        }
        setLoading(false);
      });

    } catch (error) {
      console.error('Erro ao chamar a API:', error.status);
      if (error.status === 404) {
        message.error('Erro ao gravar!');
      }
      setLoading(false);
    }
    
  };


  const [links, setLinks] = useState([])

  const handleEdit = (index) => {
    setEditingIndex(index);
    form.setFieldsValue(links[index]);
    setPreviewImage(links[index].ItemImageSrc); // Atualiza a prévia da imagem
    setModalVisible(true);
  };

  const handleDelete = (index) => {
    const updatedLinks = links.filter((_, i) => i !== index);
    setLinks(updatedLinks);
    message.success("Item removido com sucesso!");
  
    console.log("Após excluir:", JSON.stringify(updatedLinks, null, 2));
  };

  const handleAdd = () => {
    setEditingIndex(null);
    form.resetFields();
    setPreviewImage(null); // Limpa a imagem ao adicionar novo produto
    setModalVisible(true);
    console.log("Novo item adicionado, estado atual:", JSON.stringify(links, null, 2));

  };


  const handleUpload = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setPreviewImage(e.target.result); // Armazena a imagem como base64
    };
    reader.readAsDataURL(file);
    return false; // Previne o upload automático do Ant Design
  };


  


const handleSave = () => {
  form.validateFields().then((values) => {
    const newData = {
      IsLinkOrItem: values.IsLinkOrItem,
      redesociais: {
        redesocial: values.redesociais.redesocial,
        link: values.redesociais.link
      },
      ItemImageSrc: previewImage, // Agora salva a imagem base64 corretamente
      ItemText: values.ItemText || null
    };

    let updatedLinks;
    if (editingIndex !== null) {
      updatedLinks = [...links];
      updatedLinks[editingIndex] = newData;
    } else {
      updatedLinks = [...links, newData];
    }

    setLinks(updatedLinks);
    setModalVisible(false);
    form.resetFields();
    setPreviewImage(null);

    console.log("Após salvar/modificar:", JSON.stringify(updatedLinks, null, 2));
  });
};
  
  


  useEffect(() => {
    if (editingIndex !== null && links[editingIndex]) {
      const currentData = links[editingIndex];
      
      // Atualiza os estados para refletirem os dados carregados
      setTipoSelecionado(currentData.IsLinkOrItem);
      setRedeSelecionada(currentData.redesociais?.redesocial || "Nenhuma");
      setPreviewImage(currentData.ItemImageSrc);
  
      // Define os valores do formulário
      form.setFieldsValue({
        IsLinkOrItem: currentData.IsLinkOrItem,
        redesociais: {
          redesocial: currentData.redesociais?.redesocial || "Nenhuma",
          link: currentData.redesociais?.link || "",
        },
        ItemText: currentData.ItemText || "",
        ItemImageSrc: currentData.ItemImageSrc || "",
      });
    }
  }, [editingIndex, links]); // Executa sempre que o índice de edição mudar




  const moveRow = (dragIndex, hoverIndex) => {
    if (dragIndex === hoverIndex) return; 
  
    console.log(`🔄 Tentando mover item de ${dragIndex} para ${hoverIndex}`);
  
    setLinks((prevLinks) => {
      const updatedLinks = [...prevLinks];
      const [movedItem] = updatedLinks.splice(dragIndex, 1);
      updatedLinks.splice(hoverIndex, 0, movedItem);
  
      console.log("📌 Nova ordem:", updatedLinks);
      return [...updatedLinks]; // Garante um novo array para re-renderizar
    });
  };
  
  
  
  

const columns = [
  {
    title: "Ordenar",
    dataIndex: "sort",
    width: 50,
    render: () => <MenuOutlined style={{ cursor: 'grab' }} />,
  },
  {
    title: "Ações",
    key: "actions",
    render: (_, record, index) => (
      <>
        <Button icon={<EditOutlined />} onClick={() => handleEdit(index)} size="small" />
        <Button icon={<DeleteOutlined />} danger onClick={() => handleDelete(index)} size="small" />
      </>
    )
  },
  {
    title: "Tipo",
    dataIndex: ["IsLinkOrItem"],
    key: "IsLinkOrItem",
    render: (text) => <a href={text} target="_blank" rel="noopener noreferrer">{text}</a>
  },
  {
    title: "Link",
    dataIndex: ["redesociais", "link"],
    key: "link",
    render: (text) => <p>{text}</p>
  },
];

  return (
    <DndProvider backend={HTML5Backend}>
    <Container>
      <Card style={{ width: "90%", marginTop: "140px", marginBottom: "110px" }}
      bodyStyle={{ padding: 0 }}>
                <h1
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          Configuração de Links
        </h1>

        {loading ? (
              <Skeleton active />
            ) : (
              
        <div style={{ padding: 20 }}>





          <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd} style={{ marginBottom: 16 }}>
            Adicionar Novo
          </Button>

          <Button type="primary" icon={<PlusOutlined />} onClick={() => handleSaveBanco(links)} style={{ marginBottom: 16 }}>
            Salvar Links
          </Button>


          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
    
   
      <Switch checked={mostrarMapa} onChange={() => setMostrarMapa(!mostrarMapa)} /> Mostrar Mapa  &nbsp;
      <Select value={tipoMapa} onChange={setTipoMapa} disabled={!mostrarMapa}>
        <Option value="linha">Linha</Option>
        <Option value="maps">Maps</Option>
      </Select>
  


      
  <Table
    columns={columns}
    dataSource={links}
    rowKey={(_, index) => index}
    components={{
      body: {
        row: (props) => {
          return <DraggableRow {...props} index={props["data-row-key"]} moveRow={moveRow} />;
        },
      },
    }}
    pagination={false}
  />



 
{/*
          <Table 
            columns={columns} 
            dataSource={links} 
            rowKey={(_, index) => index}
            pagination={false} 
            scroll={{ x: "max-content" }}
            style={{ border: "none", margin: 0, padding: 0 }} 
            />
*/}
          <Modal 
            title={editingIndex !== null ? "Editar Link/Item" : "Adicionar Link/Item"} 
            open={modalVisible} 
            onCancel={() => setModalVisible(false)} 
            onOk={handleSave}
          >
            <Form form={form} layout="vertical">
              <Form.Item name="IsLinkOrItem" label="Tipo" rules={[{ required: true, message: "Selecione um tipo!" }]}>
              <Select onChange={(value) => setTipoSelecionado(value)}>
                  <Option value="link">Link</Option>
                  <Option value="item">Item</Option>
                </Select>
              </Form.Item>


              {/* O campo "Rede Social" só aparece se for "link" */}
              {tipoSelecionado === "link" && (
                <Form.Item
                  name={["redesociais", "redesocial"]}
                  label="Rede Social (tipo link)"
                  rules={[]}
                  initialValue="Whatsapp"
                >
                  <Select onChange={(value) => setRedeSelecionada(value)}>
                    {["Nenhuma", "Customizada", "Whatsapp", "Instagram", "Facebook", "Youtube", "TechsApp", "Twitter", "Telefone"].map((option) => (
                      <Select.Option key={option} value={option}>
                        {option}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              )}


              <Form.Item name={["redesociais", "link"]} label="Link" rules={[{ required: true, message: "Informe o link!" }]}>
                <Input />
              </Form.Item>
              <Form.Item name="ItemText" label="Texto (tipo item)">
                <Input />
              </Form.Item>


{(tipoSelecionado === "item" || redeSelecionada === "Customizada") && (
  <>
              <Form.Item name="ItemImageSrc" label="Imagem" rules={[{ required: true, message: "Selecione uma Imagem!" }]}>
            <Upload beforeUpload={handleUpload} listType="picture">
                <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
            {previewImage && <Image width={100} src={previewImage} style={{ marginTop: 10 }} />}
            </Form.Item>
  </>
)}


            </Form>
          </Modal>
        </div>
            )}
      </Card>
    </Container>
    </DndProvider>
  );
};



const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export default EditarLinks;
